export default __webpack_public_path__ + "static/media/section3_3_2_m.59f8b1c2.png";